<template>
  <div>
    <div class="card">
      <h3>订单回调</h3>
      <el-input v-model="flow" placeholder="订单号"></el-input>
      <el-button @click="payNOt">订单回调</el-button>
    </div>

    <div class="card">
      <h3>更新图片</h3>
      <p>操作：填写图片key-删除图片，删除新的图片</p>
      <p>
        https://img.curiousmore.com/图片key；如https://img.curiousmore.com/1717663210571.png的key为1717663210571.png
      </p>
      <el-input v-model="key" placeholder="图片key"></el-input>
      <el-button @click="delFile">删除图片</el-button>
      <el-upload
        class="avatar-uploader"
        action="http://up-z0.qiniup.com/"
        :data="QiNiYunL"
        :show-file-list="false"
        :on-success="successImg"
        :before-upload="getToken"
      >
        <img v-if="imageUrl" :src="imageUrl" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </div>

    <el-button @click="coachEs">coachEs</el-button>
    <el-button @click="meces">meces</el-button>
    <el-button @click="refreshESKB">refreshESKB</el-button>
    <el-button @click="refreshESDeviceInfo">refreshESDeviceInfo</el-button>

    <el-button @click="courseEs">courseEs</el-button>
    <el-button @click="venueEs">venueEs</el-button>
    <el-button @click="refreshESCustomerService"
      >refreshESCustomerService</el-button
    >
    <el-button @click="skuEs">skues</el-button>
    <el-button @click="productEs">productEs</el-button>
    <el-button @click="needInsertES">needInsertES</el-button>
     <el-button @click="clubEs">俱乐部es</el-button>
  <el-button @click="dgpEs">活动es</el-button>

    <div class="card">
      <h3>删除redis</h3>
      <el-input v-model="r_key" placeholder="key"></el-input>
      <el-button @click="delredis">删除</el-button>
    </div>

    <el-button @click="wxToken">刷新wx平台所有token</el-button>

    <el-button @click="imUserqueryListPage">imUserqueryListPage</el-button>
    <el-button @click="mecAccountDay">门店到账日</el-button>
    <el-button @click="esQuery">esQuery</el-button>
    <div class="card">
      <h3>deepseek</h3>
      <el-input
        type="textarea"
        :rows="2"
        placeholder="请输入内容"
        v-model="content"
      >
      </el-input>
      <el-button @click="sendDS">发送</el-button>
    </div>
    <el-button @click="kbes">kbes</el-button>
    <el-button @click="delIndex">delIndex</el-button>
    <el-button @click="createVectorIndex">createVectorIndex</el-button>

    <div></div>
    <el-button @click="userNeedOrderExpire">需求到期下架</el-button>
    <el-button @click="mechanismIncomeEcharts"
      >mechanismIncomeEcharts</el-button
    >

    <el-button @click="dschat">dschat</el-button>

    <el-button @click="mq">mq</el-button>
    <el-button @click="asiCoach">教练门禁推送</el-button>
    <el-button @click="wxadd">wxadd</el-button>
    <div></div>
    <el-button @click="sendudp">sendudp</el-button>
    <el-button @click="sendudp2">sendudp2</el-button>
    <el-button @click="broad">broad</el-button>
    <el-button @click="delmaes">delmaes</el-button>
    <el-button @click="mqttpu">mqttpu</el-button>
    <el-button @click="mqttsu">mqttsu</el-button>
    <el-button @click="mqttConfig">mqttConfig</el-button>
    <el-button @click="coachCoursePush">coachCoursePush</el-button>
    <el-button @click="shangjLogin">shangjLogin</el-button>
    <el-button @click="diDIvi">diDIvi</el-button>
    <el-button @click="md_h">md_h</el-button>
    <el-button @click="md_w">md_w</el-button>

    <el-button @click="md_c">md_c</el-button>
    <el-button @click="md_wc">md_wc</el-button>
    <el-button @click="md_ri">md_ri</el-button>

    <el-button @click="wx_subra">wx_subra</el-button>

    <div>
      <el-input placeholder="请输入内容" v-model="command"> </el-input>
      <el-button @click="sendCommand">sendCommand</el-button>
    </div>

    <div>
      设备用户列表
      <el-input placeholder="请输入内容" v-model="device_id"> </el-input>
      <el-button @click="getDevceUser">getDevceUser</el-button>
    </div>

    <el-button @click="coach_sys_cancel"
      >用户购买教练未确认待办任务释放</el-button
    >
     <el-button @click="devicegroupexpried"
      >活动报名截至</el-button
    >
 <el-button @click="devicegroupComplete"
      >拼场完成</el-button
    >
     <el-button @click="devicegroupSett"
      >拼场团长分成结算</el-button
    >
<el-button @click="handleGroupSettle"
      >活动结算</el-button
    >
    
    <el-button @click="enrollEsInit"
      >enrollDemandEsInit</el-button
    >
     <el-button @click="enrollExppired"
      >enrollExppired</el-button
    >
 <el-button @click="investSettle"
      >investSettle</el-button
    >
    
    
  </div>
</template>

<script>
import imageCropper from "../../components/imageCropper/imageCropper.vue";
import axios from "axios";
export default {
  components: {
    imageCropper,
  },
  data() {
    return {
      device_id: "",
      env: process.env.NODE_ENV,
      flow: "",
      key: "",
      imageUrl: "",
      QiNiYunL: {
        key: "",
        token: "",
      },
      r_key: "",
      content: "",
      coil: false,
      command: "",
    };
  },
  mounted() {
    // this.$get("/user/mechanismCardUser/sett");
  },
  methods: {
      investSettle(){
        let data = {
          venue_id: 2129,
          cash: 100,
          mechanism_id: 856
        }
      this.$post("/user/investPackageUnion/investSettle",data);
    },
      needInsertES(){
      this.$get("/user/userCourseNeed/insertEs",{});
    },
    dgpEs(){
      this.$get("/shared/dgp/refreshES",{});
    },
      handleGroupSettle(){
      this.$get("/shared/dgp/handleGroupSettle",{});
    },
       clubEs(){
      this.$post("/shared/club/insertEs",{});
    },
     enrollExppired(){
      this.$get("/user/enrollDemands/demandExpired",{pageSize:1});
    },
    enrollEsInit(){
      this.$get("/user/enrollDemands/inies",{pageSize:1});
    },
    devicegroupexpried() {
      this.$get("/shared/dgp/expired");
    },
     devicegroupComplete() {
      this.$get("/shared/dgp/complete");
    },
     devicegroupSett() {
      this.$get("/user/userAppointment/devicegroupSett");
    },
    
    coach_sys_cancel() {
      this.$get("/user/systemSendOrderRecord/courseExpired");
    },
    getDevceUser() {
      let data = {
        deviceId: this.device_id,
      };
      this.$get("/device/deviceUser/getDeviceUser", data);
    },
    wx_subra() {
      let data = {
        union_id: "ojBfv58YiwmfDR-YSo-kvtoNbvh8",
        temp_msg: "oBgd66Ax5n895WjM6CoBedgf7STE",
      };
      this.$post("/user/wxcgi/subscribe", data);
    },
    sendCommand() {
      let data = {
        device_sn: "862538064661701",
        ip: "115.231.40.94",
        port: 502,
        slaveId: 1,
        offset: 0,
        length: 1,
        command: this.command,
      };
      this.$post("/device/md/custom", data);
    },
    md_ri() {
      let data = {
        device_sn: "862538064661701",
        ip: "115.231.40.94",
        port: 502,
        slaveId: 1,
        offset: 0,
        length: 1,
      };
      this.$post("/device/md/ri", data);
    },
    md_h() {
      let data = {
        device_sn: "862538064661701",
        ip: "115.231.40.94",
        port: 502,
        slaveId: 1,
        offset: 0,
        length: 1,
      };
      this.$post("/device/md/h", data);
    },
    md_w() {
      let data = {
        device_sn: "862538064661701",
        ip: "115.231.40.94",
        port: 502,
        slaveId: 1,
        offset: 0,
        length: 1,
      };
      this.$post("/device/md/w", data);
    },
    md_c() {
      let data = {
        device_sn: "862538064661701",
        ip: "115.231.40.91",
        port: 10067,
        slaveId: 1,
        offset: 0,
        length: 100,
      };
      this.$post("/device/md/c", data);
    },
    md_wc() {
      let data = {
        device_sn: "862538064661701",
        ip: "115.231.40.94",
        port: 502,
        slaveId: 1,
        offset: 0,
        length: 1,
        coil: !this.coil,
      };
      this.$post("/device/md/wc", data);
    },

    diDIvi() {
      let data = {
        user_id: "11241",
        device_sn: "a5b30000208294c8",
      };
      this.$post("/user/userAppointment/diDivi", data);
    },
    shangjLogin() {
      let data = {};
      this.$post("/device/shangj/login", data);
    },
    coachCoursePush() {
      let data = {};
      this.$get("/user/masterAppointment/asi", data);
    },

    mqttConfig() {
      let data = {};
      this.$get("/user/userAppointment/asi", data);
    },

    mqttpu() {
      let data = { message: "{msg:23456777}" };
      this.$post("/ai/mqtt/publish", data);
    },

    mqttsu() {
      let data = {};
      this.$get("/ai/mqtt/subscribe", data);
    },

    delmaes() {
      let data = {};
      this.$get("/user/masterAppointment/deles", data);
    },

    broad() {
      let data = {};
      this.$get("/ai/udp/broadcast", data);
    },

    sendudp() {
      let data = {
        message: "笑傲i的就",
      };
      this.$get("/ai/udp/send", data);
    },
    sendudp2() {
      let data = {};
      this.$get("/ai/udp/start", data);
    },
    wxadd() {
      let data = {
        // fromUserName:'oBgd66Ax5n895WjM6CoBedgf7STE',
        // toUserName:'gh_3e134f620138',
        // union_id: 'ojBfv58YiwmfDR-YSo-kvtoNbvh8'
        temp_msg: "COACH_EXAMINE",
      };
      this.$post("/push/wx/tt", data);
    },
    asiCoach() {
      this.$post("/user/masterAppointment/asiCoach", {});
    },
    mq() {
      this.$get("/user/auction/mq", {});
    },
    esQuery() {
      this.$get("/chat/knowledgeBase/esQuery", {});
    },
    dschat() {
      axios.post(
        "/chat/ds/chat",
        { user_content: "今天天气怎么样" },
        {
          responseType: "stream",
          onDownloadProgress: (e) => {
            console.log(e.event.target);
          },
        }
      );
    },

    mechanismIncomeEcharts() {
      this.$get("/user/stat/mechanismCourseSaleData", { mechanism_id: 856 });
    },

    //需求到期下架
    userNeedOrderExpire() {
      this.$get("/user/userCourseNeed/userNeedOrderExpire", {});
    },

    kbes() {
      this.$get("/chat/customerService/es", {
        loginStatus: 1,
        // serviceStatus: 3,
        // main_platform: 1,
        // main_entry: 'need'
      });
    },

    // --------------------------------

    mecAccountDay() {
      this.$post("/user/mechanismAccountRecord/accountday", {});
    },
    wxToken() {
      this.$get("/user/wxc/tokenr", {});
    },
    delIndex() {
      this.$get("/chat/knowledgeBase/delIndex", {});
    },
    createVectorIndex() {
      this.$get("/chat/knowledgeBase/createVectorIndex", {});
    },

    refreshESCustomerService() {
      this.$get("/chat/customerService/refreshES", {});
    },
    refreshESKB() {
      let data = {};
      this.$get("/chat/knowledgeBase/refreshES", data);
    },

    refreshESDeviceInfo() {
      let data = {};
      this.$get("/device/device/refreshES", data);
    },

    delredis() {
      this.$get("/user/sms/dr", { key: this.r_key }).then((res) => {
        this.r_key = "";
      });
    },
    venueEs() {
      this.$get("/shared/sharedVenue/refreshES", {});
    },
    courseEs() {
      this.$get("/user/masterSetPrice/insertEs", {});
    },
    meces() {
      this.$get("/user/mastermechanism/insertEs", {});
    },

    pushTest() {
      this.$get("/user/pushHistory/wxpusht", {});
    },

    coachEs() {
      this.$get("/user/coach/insertEs", {});
    },

    skuEs() {
      this.$get("/user/productSku/esRe", {});
    },
    productEs() {
      this.$get("/user/product/esRe", {});
    },

    // resetDistrict(){
    //     this.$get("/user/district/updateDistrictInfo")
    // },
    // geteInfo() {
    //   this.$get("/user/esignTemp/getOrgIdentityInfo", { name: "杭州汇合" });
    //   this.$get("/user/esignTemp/getPsnIdentityInfo", { phone: "" });
    // },

    payNOt() {
      this.$axios({
        url: "/user/pay/iosPayNotify",
        data: {
          flowing_no: this.flow,
        },
        method: "post",
      }).then((res) => {
        this.$message("成功");
        this.flow = "";
      });
    },
    delFile() {
      if (!this.key) {
        this.$message("图片名称为空");
        return false;
      }
      this.$post("/push/upload/delFile", { key: this.key }).then((res) => {
        this.$message("删除成功");
      });
    },
    successImg(file) {
      this.imageUrl = this.upload_qiniu_addr + file.key;
      this.$message("上传成功");
    },
    getToken() {
      let _this = this;
      if (!this.key) {
        this.$message("图片名称为空");
        return false;
      }
      let data = {
        key: this.key,
        type: "pic",
      };
      return new Promise((resolve, reject) => {
        _this
          .$axios({
            method: "post",
            url: "https://www.curiousmore.com/qmore/push/upload/getToken",
            data: data,
          })
          .then((res) => {
            _this.QiNiYunL.token = res.data.data;
            _this.QiNiYunL.key = data.key;
            resolve();
          })
          .catch((err) => {
            console.log(err);
            reject();
          });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.card {
  padding: 20px;
  background-color: #fff;
  border-radius: 20px;
  margin-top: 20px;
}
.con-wrap {
  width: 100%;
  height: 4000px;
  width: 100%;
  background-image: linear-gradient(
    to bottom,
    rgb(155, 211, 155),
    rgb(194, 51, 51)
  );
}
.m {
  font-size: 20px;
  height: 1000px;
}
</style>